import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '@environments/environment';
import { ActionsResponse } from '@components/timeline/actions-response';

@Injectable()
export class TimelineService {
  private http = inject(HttpClient);

  apiEndpointV2 = environment.apiEndpointV2;

  getActionInSchool(params: {}): Observable<ActionsResponse> {
    const url = `${this.apiEndpointV2}/teacher/actions`;
    return this.http.get<ActionsResponse>(url, { params: params });
  }
}
